<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">엑셀 일괄업로드</span>
            <span class="txt">엑셀 일괄업로드가 필요한 데이터의 경우 여기에 올려주세요.</span>
        </div>

        <div class="com-tab">
            <button>회원관리</button>
            <button>수업관리</button>
            <button class="on">스케줄예약</button>
        </div>

        <div class="excel-info-content">
            <span class="tit">일괄 스케줄 예약 파일 업로드</span>
            <p class="txt">
                회원이 보유한 이용권에 대해 일괄 스케줄예약을 합니다.
                <br />
                엑셀 파일 다운 받기 후 정해진 형식에 맞게 정보를 입력하신 후 파일 업로드 해주세요.
            </p>
            <div class="input-area">
                <div class="line">
                    <span class="tit">엑셀 파일 다운</span>
                    <div class="edit-box">
                        <button class="com-btn down"><span>엑셀 형식 다운받기</span></button>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">데이터 올리기</span>
                    <div class="edit-box">
                        <input class="design-input" readonly type="text" />
                        <b-form-file id="file1" accept=".jpg, .png, .gif" plain></b-form-file>
                        <label for="file1">엑셀파일 찾기</label>
                        <a class="com-btn red" href="#">업로드</a>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">데이터 입력</span>
                    <div class="edit-box">
                        <button class="com-btn gray">업로드한 데이터 적용하기</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExcelSchedule',
    props: {},
    computed: {},
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>
<style lang="scss"></style>
